import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatStore } from '@application/chat.store';
import { AuthStore } from '@application/auth.store';
import { ChatPreviewComponent } from '../chat-preview/chat-preview.component';

@Component({
  selector: 'app-chat-list',
  imports: [CommonModule, FormsModule, ChatPreviewComponent],
  templateUrl: './chat-list.component.html',
  styleUrl: './chat-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatListComponent {
  private chatStore = inject(ChatStore);
  private auth = inject(AuthStore);

  showModal = output<string>();
  logoutClick = output<void>();

  readonly chats = computed(() => this.chatStore.chats());
  readonly currentUser = computed(() => this.auth.currentUser());
  readonly selectedId = computed(() => this.chatStore.selectedChat()?.id ?? null);
  readonly loading = computed(() => this.chatStore.loading());
  readonly skeletonRows = Array.from({ length: 6 });

  searchVal = '';

  onSearchInput(value: string): void {
    this.searchVal = value;
    this.chatStore.setFilter(value);
  }

  selectChat(id: string | number): void {
    this.chatStore.selectChat(id);
  }

  openProfile(): void { this.showModal.emit('profile'); }
  openNewChat(): void { this.showModal.emit('new-chat'); }
  logout(): void { this.logoutClick.emit(); }
}
